import i18n from '../../locales/index'
import restful from '../vuex'

const state = {
  ...restful.states('water')
}

const getters = {
  ...restful.getters('water')
}

const actions = {
  ...restful.actions('waters')
}

const mutations = {
  ...restful.mutations('water')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
